module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "help-center-content"
  }, [_c('h4', [_vm._v("主播等级")]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("1.\t什么是主播等级？")]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v("主播等级是喜马拉雅对主播的评估，维度包括内容质量和收益情况。")]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("2. 怎么才能拥有主播等级？")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("3.\t怎么才能升级呢？")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "500px"
    },
    attrs: {
      "src": (_vm.IMG_HOST + "anchorHelpCenter/img_level_1.png")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("4.\t主播等级在哪里看？")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "500px"
    },
    attrs: {
      "src": (_vm.IMG_HOST + "anchorHelpCenter/img_level_2.jpg")
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "500px"
    },
    attrs: {
      "src": (_vm.IMG_HOST + "anchorHelpCenter/img_level_3.jpg")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v("从入口点击进去，即可看到您的主播等级详情，包括您的等级分值、当前升级所需要的条件、解锁特权，点击右上角还可以查看升级攻略哟~")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "500px"
    },
    attrs: {
      "src": (_vm.IMG_HOST + "anchorHelpCenter/img_level_4.jpg")
    }
  }), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "500px"
    },
    attrs: {
      "src": (_vm.IMG_HOST + "anchorHelpCenter/img_level_5.jpg")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v("点击「查看等级」可查看您的等级详情：")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "500px"
    },
    attrs: {
      "src": (_vm.IMG_HOST + "anchorHelpCenter/img_level_5.jpg")
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "500px"
    },
    attrs: {
      "src": (_vm.IMG_HOST + "anchorHelpCenter/img_level_6.jpg")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("5.\t主播等级有什么用？")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "500px"
    },
    attrs: {
      "src": (_vm.IMG_HOST + "anchorHelpCenter/img_level_7.jpg")
    }
  }), _vm._v(" "), _c('p', [_vm._v("以上为本期主播等级功能权益，更多特权会陆续开通，敬请期待哦​~")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("6.\t如何提升主播等级？")]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("7.\t我是新人主播，如何快速增加我的主播等级呢？")]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v("如果您是新手主播，您可以通过参加“全民朗读”，练习朗读文章，学习主播相关技能，来提升自己的主播等级喔。当主播等级达到V4，就可以在作品有声化平台参加海选试音，迎接更大的挑战了。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("“全民朗读”参与步骤")]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v("第一步，打开喜马拉雅APP，进入“发现”页面。")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "500px",
      "border": "1px solid #eee"
    },
    attrs: {
      "src": (_vm.IMG_HOST + "anchorHelpCenter/img_26.png")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v("第二步，在“发现”页面，点击进入“全民朗读”。")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "500px",
      "border": "1px solid #eee"
    },
    attrs: {
      "src": (_vm.IMG_HOST + "anchorHelpCenter/img_27.png")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v("第三步，在“全民朗读”页面，您可以自由选择不同主题或作家的文章进行朗读。点击“读这篇”进入录制界面。")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "500px",
      "border": "1px solid #eee"
    },
    attrs: {
      "src": (_vm.IMG_HOST + "anchorHelpCenter/img_28.png")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v("第四步，点击录音按钮，即可开始朗读，加油增长等级吧")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "500px",
      "border": "1px solid #eee"
    },
    attrs: {
      "src": (_vm.IMG_HOST + "anchorHelpCenter/img_29.png")
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "content"
  }, [_vm._v("通过实名认证即可至V0；再上传三条声音即可升级至V1（每条声音都要大于1分钟哦）\n        "), _c('br'), _vm._v("升级至V1后，就正式进入等级体系啦，会获得尊贵等级标识哦！")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "content"
  }, [_vm._v("当有人在喜马拉雅完整收听你的节目或者获得收入，就可以获得等级分。等级分达到升级所需分值，就可以升到相应的等级啦。\n        "), _c('br'), _c('strong', [_vm._v("等级和等级分对应表")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "content"
  }, [_vm._v("① "), _c('strong', [_vm._v("手机端（需要升级到喜马拉雅最新版本6.3.27哦）")]), _vm._v(" "), _c('br'), _vm._v("入口：「我的」页面右上角>点击进入「主播工作台」> 点击等级模块\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "content"
  }, [_vm._v("②"), _c('strong', [_vm._v("网页端")]), _vm._v(" "), _c('br'), _vm._v("入口：主播工作台首页>查看等级\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "content"
  }, [_vm._v("主播等级的作用可是大大的哦：\n        "), _c('br'), _vm._v("①解锁功能，获得资源倾斜\n        "), _c('br'), _vm._v("②获得精准指导和帮扶\n        "), _c('br'), _vm._v("③在同行压力和激励下不断进步")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "content"
  }, [_c('strong', [_vm._v("1） 解锁功能权限，获得资源倾斜")]), _vm._v(" "), _c('br'), _vm._v("喜马拉雅会根据主播等级，匹配相应的功能权限，资源上也会倾斜向有潜力的主播。\n        "), _c('br'), _c('br'), _c('strong', [_vm._v("主播等级权益表")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "content"
  }, [_c('strong', [_vm._v("2）获得精准的指导和帮扶")]), _vm._v(" "), _c('br'), _vm._v("喜马拉雅会根据主播当前的等级，评估成长状况，更精准提供相应的帮助和指导服务。\n        "), _c('br'), _c('br'), _vm._v("3） 同行的压力和激励\n        一个人默默努力经常会软弱和疲倦，喜马拉雅有数十万主播与您一起为创作优质节目而努力，在等级体系中，找到自己在发展路线上的标杆和榜样，从他们的想法和做法中受到启发，让自己躺着也能进步哦")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "content"
  }, [_vm._v("会影响到您等级分的因素主要有2个：①累计节目收听的人数、②总共获得的收入。另外，平台资源使用也会对等级分有一点影响。以下方法可以有效提升您的等级。\n        "), _c('br'), _c('br'), _c('strong', [_vm._v("① 发布优质节目，保持稳定更新频率")]), _vm._v(" "), _c('br'), _vm._v("优质节目是前提，保证有一定的节目数量和稳定的更新频率，为优秀主播快速升级和成长奠定基础。新手主播可以通过参加“全民朗读”，朗读文章来提升自己的技能，增长等级哦。\n        "), _c('br'), _c('br'), _c('strong', [_vm._v("②积极广节目，吸引更多人收听")]), _vm._v(" "), _c('br'), _vm._v("节目收听人数越高，等级分值越高。需要注意的是，除了播放量，您还需要关注节目数据表现，完播率过低，不会被计入等级分哦。\n        "), _c('br'), _vm._v("主播等级可以自动生成分享海报，逼格满满，分享到朋友圈或者微博等自媒体，是吸引听众的利器哟。\n        "), _c('br'), _c('br'), _c('strong', [_vm._v("③ 培养粉丝的付费习惯")]), _vm._v("\n        收益越高，等级分越高。引导粉丝为您的内容创作付费，比如购买付费节目，直播送礼，为免费节目赞助打赏等，会提升您的收益，也能正向激励您创作更优质的内容。\n        "), _c('br'), _c('br'), _c('strong', [_vm._v("④ 申请绿色通道")]), _vm._v(" "), _c('br'), _vm._v("在其他自媒体平台已有较高名气和粉丝量，认证时可申请名人名企通道，主播助手审核会酌情加分\n        "), _c('br'), _c('br'), _c('strong', [_vm._v("⑤ 爱惜平台资源")]), _vm._v(" "), _c('br'), _vm._v("不要上传大量低质量的节目，滥用平台资源会提升您的成本评估，从而降低您的等级分值\n        "), _c('br'), _c('br'), _vm._v("以上是为您总结的几条升级建议，期待您在喜马拉雅获得提升和成长么么哒！\n    ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e865c214!./~/vue-loader/lib/selector.js?type=template&index=0!./views/anchor/helpCenter/AnchorLevelTips.vue
// module id = 391
// module chunks = 0